export enum DocumentState {
  Attached = 'attached',
  Invalidated = 'invalidated',
  Pending = 'pending',
  Validated = 'validated',
}

export enum ProfileTypes {
  Consultant = 'Consultant',
  TeamLeader = 'TeamLeader',
}
